module.exports = __webpack_public_path__ + "img/6.dc2467f7.jpg";